import * as React from 'react';

import {
  Colors,
  Lang,
} from '@bluecurrent/web-component-lib';

import handleCurrencyFormat from '../../../../../../../../functions/handleCurrencyFormat';

import Item from './Item';

import handleItemValueCalucation from '../../functions/handleItemValueCalculation';

export default function YAxis({
  data,
  isLoading,
}) {
  const { i18n } = Lang.useTranslation();

  const [seperators, setSeperators] = React.useState([]);

  React.useEffect(() => {
    if (isLoading) setSeperators([]);

    setSeperators(
      handleItemValueCalucation(
        data
          .filter((item) => item.amount !== undefined)
          .map((item) => item.amount),
      ).array,
    );
  }, [data, isLoading]);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        borderLeft: `solid 4px ${Colors.MEDIUM_GREY}`,
        backgroundColor: Colors.WHITE,
        position: 'relative',
        zIndex: 1,
      }}
    >
      <div
        style={{
          height: 'calc(100% - 76px)',
          width: '100%',
          marginTop: 20,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
        }}
      >
        {
          seperators.map((item) => (
            <Item
              key={item.id}
              text={handleCurrencyFormat(i18n, Number(item.amount), item.amount_currency)}
              isLoading={isLoading}
            />
          ))
        }
      </div>
    </div>
  );
}
